<template>
  <div class="terms-of-acceptance-page">
    <app-page-header title="Termos de aceitação">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus"></b-icon>NOVO
      </button>
    </app-page-header>
    <terms-of-acceptance-table></terms-of-acceptance-table>
  </div>
</template>

<script>
import TermsOfAcceptanceTable from '@/components/Tables/TermsOfAcceptanceTable.vue';

export default {
  name: 'terms-of-acceptance-page',
  components: {
    TermsOfAcceptanceTable,
  },
  methods: {
    create() {
      this.$router.push('/terms-of-acceptance/create');
    },
  },
};
</script>

<style lang="sass" scoped></style>
